<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['meses'],
  mounted () {
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Augosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      datasets: [
        {
          label: 'Fluxo do Stock',
          backgroundColor: '#f87979',
          data: [this.meses[0], this.meses[1], this.meses[2], this.meses[3], this.meses[4], this.meses[5], this.meses[6], this.meses[7], this.meses[8], this.meses[9], this.meses[10], this.meses[11]]
        }
      ]
    })
  }
}
</script>
